declare module 'vue/types/vue' {
  interface VueConstructor {
    $net: any
  }
}

import "./router/componentHooks" // <-- Needs to be first
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store'
import net from '@/net'
import Notifications from 'vue-notification'
import 'vue-search-select/dist/VueSearchSelect.css'
import VueAppInsights from 'vue-application-insights'

Vue.use(net)
Vue.use(Notifications)
//create event bus to communicate between component
export const bus =  new Vue();
Vue.config.productionTip = false;

Vue.use(VueAppInsights, {
  id: '78cef0d7-5c04-41e5-abc9-0df76ba9693c',
  router
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
